import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getServiceOperationTypes = async (token) => {
    log("welcome in getServiceOperationTypes")

    if (!token || token === "") {
        return {error: true, message: "No token provided", operation_types: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_service_operation_types_api'
        log("url=" + url)

        const result = await axios.get(url, {headers: headers})
        log("result.data din axios getServiceOperationTypes")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getServiceOperationTypes")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getServiceOperationTypes", operation_types: []}
    }
}

export const addServiceOperationType = async (token, data) => {
    log("welcome in addServiceOperationType")
    log("data:")
    log(data)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/add_service_operation_type_api'
        log("url=" + url)

        const payload = {
            name: data.name,
            label: data.label || null,
            color: data.color || 'grey'
        }

        const result = await axios.post(url, payload, {headers: headers})
        log("result.data din axios addServiceOperationType")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in addServiceOperationType")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la addServiceOperationType"}
    }
}

export const updateServiceOperationType = async (token, data) => {
    log("welcome in updateServiceOperationType")
    log("data:")
    log(data)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/update_service_operation_type_api'
        log("url=" + url)

        const payload = {
            id: data.id,
            name: data.name,
            label: data.label,
            color: data.color
        }

        const result = await axios.put(url, payload, {headers: headers})
        log("result.data din axios updateServiceOperationType")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in updateServiceOperationType")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la updateServiceOperationType"}
    }
}

export const deleteServiceOperationType = async (token, id) => {
    log("welcome in deleteServiceOperationType")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/delete_service_operation_type_api'
        log("url=" + url)

        const result = await axios.delete(url, {headers: headers, data: {id: id}})
        log("result.data din axios deleteServiceOperationType")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in deleteServiceOperationType")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la deleteServiceOperationType"}
    }
}

const useServiceOperationTypesAPI = () => {
    return {
        error,
        getServiceOperationTypes,
        addServiceOperationType,
        updateServiceOperationType,
        deleteServiceOperationType
    }
}

export default useServiceOperationTypesAPI
